import React from 'react'
import Styles from "../auth/_auth.module.css";
const PageNotFound = () => {
  return (
    <div className={Styles.PageNotFound}>PageNotFound</div>
  )
}

export default PageNotFound